import ReactGA from 'react-ga4';
import { clarityEvent } from './clarity';

// ReactGA is initialized once in components/Analytics.jsx (guarded by VITE_GA_ID).
const ENABLED = Boolean(import.meta.env.VITE_GA_ID);

/**
 * Fire a GA4 event, and mirror it onto the Clarity session timeline so the
 * recording of the same moment is findable. No-op when either is unavailable.
 */
export function trackEvent(name, params = {}) {
  clarityEvent(name);
  if (!ENABLED) return;
  try { ReactGA.event(name, params); } catch { /* never break the app for analytics */ }
}
